import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { GeographicLevel } from 'app/shared/model/enumerations/geographic-level.model';
import { createEntity, getEntity, reset, updateEntity } from './industry.reducer';

export const IndustryUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const industryEntity = useAppSelector(state => state.industry.entity);
  const loading = useAppSelector(state => state.industry.loading);
  const updating = useAppSelector(state => state.industry.updating);
  const updateSuccess = useAppSelector(state => state.industry.updateSuccess);
  const geographicLevelValues = Object.keys(GeographicLevel);

  const handleClose = () => {
    navigate(`/industry${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.totalAllUsualResidents !== undefined && typeof values.totalAllUsualResidents !== 'number') {
      values.totalAllUsualResidents = Number(values.totalAllUsualResidents);
    }
    if (values.agricultureForestryFishing !== undefined && typeof values.agricultureForestryFishing !== 'number') {
      values.agricultureForestryFishing = Number(values.agricultureForestryFishing);
    }
    if (values.miningQuarrying !== undefined && typeof values.miningQuarrying !== 'number') {
      values.miningQuarrying = Number(values.miningQuarrying);
    }
    if (values.manufacturing !== undefined && typeof values.manufacturing !== 'number') {
      values.manufacturing = Number(values.manufacturing);
    }
    if (values.electricityGasWater !== undefined && typeof values.electricityGasWater !== 'number') {
      values.electricityGasWater = Number(values.electricityGasWater);
    }
    if (values.construction !== undefined && typeof values.construction !== 'number') {
      values.construction = Number(values.construction);
    }
    if (values.wholesaleRetailTrade !== undefined && typeof values.wholesaleRetailTrade !== 'number') {
      values.wholesaleRetailTrade = Number(values.wholesaleRetailTrade);
    }
    if (values.transportationStorage !== undefined && typeof values.transportationStorage !== 'number') {
      values.transportationStorage = Number(values.transportationStorage);
    }
    if (values.accommodationFoodService !== undefined && typeof values.accommodationFoodService !== 'number') {
      values.accommodationFoodService = Number(values.accommodationFoodService);
    }
    if (values.informationCommunication !== undefined && typeof values.informationCommunication !== 'number') {
      values.informationCommunication = Number(values.informationCommunication);
    }
    if (values.financialInsurance !== undefined && typeof values.financialInsurance !== 'number') {
      values.financialInsurance = Number(values.financialInsurance);
    }
    if (values.realEstate !== undefined && typeof values.realEstate !== 'number') {
      values.realEstate = Number(values.realEstate);
    }
    if (values.professionalScientific !== undefined && typeof values.professionalScientific !== 'number') {
      values.professionalScientific = Number(values.professionalScientific);
    }
    if (values.administrativeSupport !== undefined && typeof values.administrativeSupport !== 'number') {
      values.administrativeSupport = Number(values.administrativeSupport);
    }
    if (values.publicAdministration !== undefined && typeof values.publicAdministration !== 'number') {
      values.publicAdministration = Number(values.publicAdministration);
    }
    if (values.education !== undefined && typeof values.education !== 'number') {
      values.education = Number(values.education);
    }
    if (values.humanHealthSocialWork !== undefined && typeof values.humanHealthSocialWork !== 'number') {
      values.humanHealthSocialWork = Number(values.humanHealthSocialWork);
    }
    if (values.artsEntertainment !== undefined && typeof values.artsEntertainment !== 'number') {
      values.artsEntertainment = Number(values.artsEntertainment);
    }
    if (values.otherServiceActivities !== undefined && typeof values.otherServiceActivities !== 'number') {
      values.otherServiceActivities = Number(values.otherServiceActivities);
    }
    if (values.householdEmployers !== undefined && typeof values.householdEmployers !== 'number') {
      values.householdEmployers = Number(values.householdEmployers);
    }

    const entity = {
      ...industryEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          geographicLevel: 'EXTRA_WARD',
          ...industryEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="apiLocationApp.industry.home.createOrEditLabel" data-cy="IndustryCreateUpdateHeading">
            <Translate contentKey="apiLocationApp.industry.home.createOrEditLabel">Create or edit a Industry</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="industry-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('apiLocationApp.industry.geographicLevel')}
                id="industry-geographicLevel"
                name="geographicLevel"
                data-cy="geographicLevel"
                type="select"
              >
                {geographicLevelValues.map(geographicLevel => (
                  <option value={geographicLevel} key={geographicLevel}>
                    {translate(`apiLocationApp.GeographicLevel.${geographicLevel}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('apiLocationApp.industry.date')}
                id="industry-date"
                name="date"
                data-cy="date"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.industry.geography')}
                id="industry-geography"
                name="geography"
                data-cy="geography"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.industry.geographyCode')}
                id="industry-geographyCode"
                name="geographyCode"
                data-cy="geographyCode"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.industry.totalAllUsualResidents')}
                id="industry-totalAllUsualResidents"
                name="totalAllUsualResidents"
                data-cy="totalAllUsualResidents"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.industry.agricultureForestryFishing')}
                id="industry-agricultureForestryFishing"
                name="agricultureForestryFishing"
                data-cy="agricultureForestryFishing"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.industry.miningQuarrying')}
                id="industry-miningQuarrying"
                name="miningQuarrying"
                data-cy="miningQuarrying"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.industry.manufacturing')}
                id="industry-manufacturing"
                name="manufacturing"
                data-cy="manufacturing"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.industry.electricityGasWater')}
                id="industry-electricityGasWater"
                name="electricityGasWater"
                data-cy="electricityGasWater"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.industry.construction')}
                id="industry-construction"
                name="construction"
                data-cy="construction"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.industry.wholesaleRetailTrade')}
                id="industry-wholesaleRetailTrade"
                name="wholesaleRetailTrade"
                data-cy="wholesaleRetailTrade"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.industry.transportationStorage')}
                id="industry-transportationStorage"
                name="transportationStorage"
                data-cy="transportationStorage"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.industry.accommodationFoodService')}
                id="industry-accommodationFoodService"
                name="accommodationFoodService"
                data-cy="accommodationFoodService"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.industry.informationCommunication')}
                id="industry-informationCommunication"
                name="informationCommunication"
                data-cy="informationCommunication"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.industry.financialInsurance')}
                id="industry-financialInsurance"
                name="financialInsurance"
                data-cy="financialInsurance"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.industry.realEstate')}
                id="industry-realEstate"
                name="realEstate"
                data-cy="realEstate"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.industry.professionalScientific')}
                id="industry-professionalScientific"
                name="professionalScientific"
                data-cy="professionalScientific"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.industry.administrativeSupport')}
                id="industry-administrativeSupport"
                name="administrativeSupport"
                data-cy="administrativeSupport"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.industry.publicAdministration')}
                id="industry-publicAdministration"
                name="publicAdministration"
                data-cy="publicAdministration"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.industry.education')}
                id="industry-education"
                name="education"
                data-cy="education"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.industry.humanHealthSocialWork')}
                id="industry-humanHealthSocialWork"
                name="humanHealthSocialWork"
                data-cy="humanHealthSocialWork"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.industry.artsEntertainment')}
                id="industry-artsEntertainment"
                name="artsEntertainment"
                data-cy="artsEntertainment"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.industry.otherServiceActivities')}
                id="industry-otherServiceActivities"
                name="otherServiceActivities"
                data-cy="otherServiceActivities"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.industry.householdEmployers')}
                id="industry-householdEmployers"
                name="householdEmployers"
                data-cy="householdEmployers"
                type="text"
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/industry" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default IndustryUpdate;
